import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'current-sked-checkbox',
  templateUrl: './current-sked-checkbox.component.html',
  styleUrls: ['./current-sked-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedCheckboxComponent {
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Input() loading: boolean;

  @Output() checkboxClick = new EventEmitter<boolean>();

  onButton(event: MouseEvent) {
    event.stopPropagation();
    this.checkboxClick.emit(!this.checked);
  }
}
